import { z } from "zod";
export const dmaCalculationRunStageSchema = z.object({
    startedAt: z.string().datetime(),
    message: z.string(),
});
